import { render, staticRenderFns } from "./CargoCostSettlement.vue?vue&type=template&id=6c8bc329&scoped=true"
import script from "./CargoCostSettlement.vue?vue&type=script&lang=js"
export * from "./CargoCostSettlement.vue?vue&type=script&lang=js"
import style0 from "./CargoCostSettlement.vue?vue&type=style&index=0&id=6c8bc329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8bc329",
  null
  
)

export default component.exports